// ContactUs.js
import React from 'react';
import { Box, Grid, Typography, IconButton, Stack } from '@mui/material';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';

const ContactUs = () => {
  const BG_IMG =
    'https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/background_01.jpg';

  return (
    <Box id="contact" sx={{ py: { xs: 6, md: 8 }, bgcolor: '#fff' }}>
      <Box sx={{ maxWidth: 1400, mx: 'auto', px: 0 }}>
        <Box
          sx={{
            position: 'relative',
            borderRadius: { xs: 6, md: 10 },
            overflow: 'hidden',
            minHeight: { xs: 220, md: 300 },
            color: '#fff',
            // FULL BLEED BG
            backgroundImage: `url(${BG_IMG})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          {/* overlay for readability */}
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(90deg, rgba(255,127,0,0.72) 0%, rgba(255,127,0,0.55) 45%, rgba(255,127,0,0.35) 100%)'
            }}
          />

          {/* bubbles */}
          <Box
            sx={{
              position: 'absolute',
              left: { xs: -40, md: -55 },
              bottom: { xs: -45, md: -60 },
              width: { xs: 120, md: 160 },
              height: { xs: 120, md: 160 },
              borderRadius: '50%',
              background:
                'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.55), rgba(255,255,255,0.08) 60%, rgba(255,255,255,0.0) 70%)',
              border: '1px solid rgba(255,255,255,0.25)',
              pointerEvents: 'none',
              zIndex: 1
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              right: { xs: 26, md: 54 },
              top: { xs: 24, md: 22 },
              width: { xs: 84, md: 110 },
              height: { xs: 84, md: 110 },
              borderRadius: '50%',
              background:
                'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.5), rgba(255,255,255,0.10) 60%, rgba(255,255,255,0.0) 72%)',
              border: '1px solid rgba(255,255,255,0.25)',
              pointerEvents: 'none',
              zIndex: 1
            }}
          />

          {/* content (ONLY text has padding, background stays full) */}
          <Grid
            container
            spacing={4}
            alignItems="center"
            sx={{
              position: 'relative',
              zIndex: 2,
              px: { xs: 3, md: 8 }, // padding for content only
              py: { xs: 5, md: 6 }
            }}
          >
            <Grid item xs={12} md={7}>
              <Typography
                sx={{
                  fontFamily: '"Caveat", cursive',
                  fontSize: { xs: 22, md: 26 },
                  fontWeight: 700,
                  opacity: 0.95,
                  mb: 1
                }}
              >
                Contact us
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: 34, sm: 40, md: 52 },
                  fontWeight: 900,
                  lineHeight: 1.05,
                  letterSpacing: '-0.03em',
                  maxWidth: 760
                }}
              >
                Book online, by phone, or <br />
                through social media.
              </Typography>
            </Grid>

            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: { xs: 'flex-start', md: 'flex-end' },
                  gap: { xs: 2.5, md: 3.5 },
                  mt: { xs: 2, md: 0 }
                }}
              >
                <Stack direction="row" spacing={1.2} alignItems="center">
                  {[
                    { Icon: FacebookIcon, label: 'Facebook' },
                    { Icon: InstagramIcon, label: 'Instagram' },
                    { Icon: XIcon, label: 'X' }
                  ].map(({ Icon, label }) => (
                    <IconButton
                      key={label}
                      aria-label={label}
                      sx={{
                        width: 46,
                        height: 46,
                        borderRadius: '50%',
                        border: '1px solid rgba(255,255,255,0.45)',
                        color: '#fff',
                        '&:hover': { backgroundColor: 'rgba(255,255,255,0.12)' }
                      }}
                    >
                      <Icon sx={{ fontSize: 22 }} />
                    </IconButton>
                  ))}
                </Stack>

                <Box
                  component="a"
                  href="/book-service"
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1.5,
                    color: '#fff',
                    textDecoration: 'none',
                    fontWeight: 800,
                    fontSize: { xs: 18, md: 20 },
                    whiteSpace: 'nowrap'
                  }}
                >
                  Book Online
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255,255,255,0.25)',
                      display: 'grid',
                      placeItems: 'center',
                      border: '2px solid rgba(255,255,255,0.6)'
                    }}
                  >
                    <ArrowOutwardIcon sx={{ color: '#fff' }} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUs;
